/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MonitoringTemplateTrackRequest } from './MonitoringTemplateTrackRequest';
import {
    MonitoringTemplateTrackRequestFromJSON,
    MonitoringTemplateTrackRequestFromJSONTyped,
    MonitoringTemplateTrackRequestToJSON,
} from './MonitoringTemplateTrackRequest';

/**
 * 
 * @export
 * @interface MonitoringTemplateRequest
 */
export interface MonitoringTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof MonitoringTemplateRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof MonitoringTemplateRequest
     */
    description?: string;
    /**
     * 
     * @type {Array<MonitoringTemplateTrackRequest>}
     * @memberof MonitoringTemplateRequest
     */
    tracks: Array<MonitoringTemplateTrackRequest>;
}

/**
 * Check if a given object implements the MonitoringTemplateRequest interface.
 */
export function instanceOfMonitoringTemplateRequest(value: object): value is MonitoringTemplateRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('tracks' in value) || value['tracks'] === undefined) return false;
    return true;
}

export function MonitoringTemplateRequestFromJSON(json: any): MonitoringTemplateRequest {
    return MonitoringTemplateRequestFromJSONTyped(json, false);
}

export function MonitoringTemplateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitoringTemplateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'tracks': ((json['tracks'] as Array<any>).map(MonitoringTemplateTrackRequestFromJSON)),
    };
}

export function MonitoringTemplateRequestToJSON(value?: MonitoringTemplateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'description': value['description'],
        'tracks': ((value['tracks'] as Array<any>).map(MonitoringTemplateTrackRequestToJSON)),
    };
}

